import { Check, CheckCircle, Delete, Folder, WarningAmber } from "@mui/icons-material"
import { KeyDriveDialog } from "../../../components/KeydriveComponents/Dialog/KeyDriveDialog"
import { KeyDriveh2Header } from "../../../components/KeydriveComponents/Fonts/Headers/KeyDriveh2Header"
import { KeyDriveTab3 } from "../../../components/KeydriveComponents/Tabs/KeydriveTab3"
import { KeyDriveTabPanel } from "../../../components/KeydriveComponents/Tabs/components/KeyDriveTabPanel"
import { KeyDriveTable } from "../../../components/KeydriveComponents/Tables/KeyDriveTable"
import { CircularProgress, TableCell, TableRow } from "@mui/material"
import WorkSpaceItemListFileComponentImage from "../WorkSpaceItemListFileComponentImage"
import { KeyDriveBodyMin } from "../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin"
import KeydriveTooltip from "../../../components/KeydriveComponents/Tooltip/KeydriveTooltip"
import { IBatchDeleteReturn } from "../../../model/OrganizationModel"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from "react-router-dom"

export interface IDeleteInBatchModal {
    batchDeleteResult: IBatchDeleteReturn | undefined;
    setOpenDeleteBatchModal: (set: boolean) => void;
    openDeleteBatchModal: boolean;
}

export default function DeleteInBatchModal({
    batchDeleteResult,
    openDeleteBatchModal,
    setOpenDeleteBatchModal
}: IDeleteInBatchModal) {

    const [value, setValue] = useState<number>(0);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { nameOrg } = useParams();

    return (
        <KeyDriveDialog 
            keyDriveDialogButtons={{
                leftButtonMethod: () => {
                    setOpenDeleteBatchModal(false);
                },
                rightButtonMethod: () => {
                    navigate(`/${nameOrg}/recycleBin/`);
                },
                rightButtonText: t("DeleteInBatchDialog.GoToRecycleBin"),
                leftButtonText: t("DeleteInBatchDialog.Close")
            }}
            keyDriveDialogContent={{
                dialogContent: (
                    <>
                        { batchDeleteResult == undefined ? (
                            <CircularProgress variant="indeterminate" />
                        ) : (
                            <>                            
                                <div style={{marginBottom: "20px"}}>
                                    <KeyDriveh2Header 
                                    color="#000"
                                    needBold={false}
                                    needEllipses={false}
                                    text={t("DeleteInBatchDialog.Title")}
                                />
                                </div>
                                <KeyDriveTab3
                                    icon1={<Delete />}
                                    icon2={<Folder />}
                                    icon3={<Check />}
                                    label1={t("DeleteInBatchDialog.Selected")}
                                    label2={t("DeleteInBatchDialog.DeletedSuccessfully")}
                                    label3={t("DeleteInBatchDialog.NotDeleted")}
                                    onChange={(ev, i) => { setValue(i) }}
                                >
                                    <KeyDriveTabPanel
                                        index={0}
                                        value={value}
                                    >
                                        <KeyDriveTable
                                            headers={[t("DeleteInBatchDialog.Name"), t("DeleteInBatchDialog.Extension"), t("DeleteInBatchDialog.Status")]}
                                            needFooter={false}
                                            body={batchDeleteResult?.deletedItemsId?.map(({
                                                itemId,
                                                itemName,
                                                fileExtension
                                            }) => (
                                                <TableRow key={itemId} sx={{ '& > *': { borderBottom: 'unset' }, borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>
                                                    <TableCell sx={{border: "none"}}></TableCell>
                                                    <TableCell sx={{border: "none", display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <WorkSpaceItemListFileComponentImage boxLayout={false} extension={fileExtension}isFolder={false} widthIcon="20px" />
                                                        <KeyDriveBodyMin
                                                            color="#2D2D2D"
                                                            needBold
                                                            needEllipses={false}
                                                            text={itemName}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{border: "none"}}>
                                                        <KeyDriveBodyMin
                                                            color="#2D2D2D"
                                                            needBold
                                                            needEllipses={false}
                                                            text={fileExtension}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{border: "none", display: "flex", justifyContent: "center" }}>
                                                        <CheckCircle />
                                                    </TableCell>
                                                </TableRow>
                                            )) }
                                            footerData={undefined}
                                            currentPage={0}
                                            dataPerPage={0}
                                            onPageChange={() => {}}
                                        />
                                    </KeyDriveTabPanel>
                                    <KeyDriveTabPanel
                                        index={1}
                                        value={value}
                                    >
                                        <KeyDriveTable
                                            headers={[t("DeleteInBatchDialog.Name"), t("DeleteInBatchDialog.Extension"), t("DeleteInBatchDialog.Status")]}
                                            needFooter={false}
                                            body={batchDeleteResult?.itemsDeletedSuccesfully?.map(({
                                                itemId,
                                                itemName,
                                                fileExtension
                                            }) => (
                                                <TableRow key={itemId} sx={{ '& > *': { borderBottom: 'unset' }, borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>
                                                    <TableCell sx={{border: "none"}}></TableCell>
                                                    <TableCell sx={{border: "none", display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <WorkSpaceItemListFileComponentImage boxLayout={false} extension={fileExtension}isFolder={false} widthIcon="20px" />
                                                        <KeyDriveBodyMin
                                                            color="#2D2D2D"
                                                            needBold
                                                            needEllipses={false}
                                                            text={itemName}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{border: "none"}}>
                                                        <KeyDriveBodyMin
                                                            color="#2D2D2D"
                                                            needBold
                                                            needEllipses={false}
                                                            text={fileExtension}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{border: "none", display: "flex", justifyContent: "center" }}>
                                                        <CheckCircle />
                                                    </TableCell>
                                                </TableRow>
                                            )) }
                                            footerData={undefined}
                                            currentPage={0}
                                            dataPerPage={0}
                                            onPageChange={() => {}}
                                        />
                                    </KeyDriveTabPanel>
                                    <KeyDriveTabPanel
                                        index={2}
                                        value={value}
                                    >
                                        <KeyDriveTable
                                            headers={[t("DeleteInBatchDialog.Name"), t("DeleteInBatchDialog.Extension"), t("DeleteInBatchDialog.Status")]}
                                            needFooter={false}
                                            body={batchDeleteResult?.itemsWithErrors?.map(({
                                                itemId,
                                                itemName,
                                                fileExtension,
                                                errorReason
                                            }) => (
                                                <TableRow key={itemId} sx={{ '& > *': { borderBottom: 'unset' }, borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>
                                                    <TableCell sx={{border: "none"}}></TableCell>
                                                    <TableCell sx={{border: "none", display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <WorkSpaceItemListFileComponentImage boxLayout={false} extension={fileExtension}isFolder={false} widthIcon="20px" />
                                                        <KeyDriveBodyMin
                                                            color="#2D2D2D"
                                                            needBold
                                                            needEllipses={false}
                                                            text={itemName}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{border: "none"}}>
                                                        <KeyDriveBodyMin
                                                            color="#2D2D2D"
                                                            needBold
                                                            needEllipses={false}
                                                            text={fileExtension}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{border: "none", display: "flex", justifyContent: "center" }}>
                                                        <KeydriveTooltip title={errorReason}>
                                                            <WarningAmber />
                                                        </KeydriveTooltip>
                                                    </TableCell>
                                                </TableRow>
                                            )) }
                                            footerData={undefined}
                                            currentPage={0}
                                            dataPerPage={0}
                                            onPageChange={() => {}}
                                        />
                                    </KeyDriveTabPanel>
                                </KeyDriveTab3>
                            </>
                        ) }
                    </>
                ),
                handleTogglDialog: () => {},
                openDialog: openDeleteBatchModal,
            }}
        />
    )
}